import purchrAxios from './purchrAxios';

class AlertsFiredService {
  // Paginated, server-filtered alert history.
  // params: { limit, pageNo, q, productId }
  static async getAlertsByUserId(userId, params = {}) {
    try {
      const response = await purchrAxios.get(`/firealerts/alerts`, {
        params: { user_id: userId, ...params },
      });
      return response.data;
    } catch (error) {
      console.error('Failed to fetch alerts:', error.response ? error.response.data : error.message);
      throw error;
    }
  }

  // Distinct products the user has alerts for (for the filter dropdown).
  static async getProducts(userId) {
    const response = await purchrAxios.get(`/firealerts/products`, {
      params: { user_id: userId },
    });
    return response.data;
  }
}

export default AlertsFiredService;
